
let elementMap: { [tagName: string]: HTMLElement } = {};
/**
 * check if element supports a particular attribute
 * @param tagName
 * @param attrName
 */
export default function (tagName: string, attrName: string) {
    let e = elementMap[tagName] || document.createElement(tagName);
    elementMap[tagName] = e;
    return (attrName in e);
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/browserCaps.ts